var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.615 0.370117H27.4325C11.33 0.370117 0.5 11.6751 0.5 28.4901V67.2976C0.5 84.0651 11.33 95.3701 27.4325 95.3701H68.615C84.7175 95.3701 95.5 84.0651 95.5 67.2976V28.4901C95.5 11.6751 84.7175 0.370117 68.615 0.370117Z",
    fill: "#356733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.363 63.2978C41.299 63.2978 40.235 62.8941 39.4227 62.0818L28.151 50.8101C26.5265 49.1856 26.5265 46.5541 28.151 44.9343C29.7755 43.3098 32.4022 43.3051 34.0267 44.9296L42.363 53.2658L61.971 33.6578C63.5955 32.0333 66.2222 32.0333 67.8467 33.6578C69.4712 35.2823 69.4712 37.9138 67.8467 39.5383L45.3032 62.0818C44.491 62.8941 43.427 63.2978 42.363 63.2978Z",
    fill: "#FFD456"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/CheckBox.b0406907c3923eee3ba8bd7d30725841.svg";
export { ForwardRef as ReactComponent };